import { cardItems } from '@/mocks/home';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-accent-600 mb-2">深度阅读</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选推荐</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">精心策划的影视专题与深度内容，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, i) => (
            <article
              key={item.id}
              className={`group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="700"
                  height="420"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-400">{item.author}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed flex-1">
                  {item.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600 whitespace-nowrap">
                  阅读全文
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}